<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12" style="background:white;padding:10px;">
                    <h2 v-if="resp == 'OK'">Az új jelszavadat kiküldtük az email címedre.</h2>
                    <h2 v-if="resp == 'FAIL'">Hibás vagy lejárt token.</h2>
                </div>
            </div>
        </div>

        <footer-view></footer-view>
    </div>
</template>

<script>
import FooterView from '@components/bora/Footer.vue'
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    components:{
        FooterView
    },
    data:function () {
        return {
            resp:null,
        };
    },
    created:function () {
        var self = this;
        this.connForgotPassValidation(this.$route.query.token,function (r) {
            self.resp = r.data.message;
        })
    }
}
</script>



// WEBPACK FOOTER //
// NewPass.vue?756165da